module.exports = __webpack_public_path__ + "img/tanis.0b3cd6db.png";